import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader, Spinner, useApiQuery } from '@/modules/common';
import { Routes } from '@/router/routes';

import { ModelsTable } from '../components';
import { Model } from '../types';

export const ModelsPage: FC = () => {
  const navigate = useNavigate();
  const { isFetching, data } = useApiQuery<Model[]>('/models', {
    queryKey: ['models'],
    initialData: [],
  });

  const redirectToModel = (item) => {
    navigate(Routes.ModelDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Models"
        actions={[
          <Link
            to={Routes.NewModel}
            key="new-model"
            data-testid="add-new-model-link"
          >
            <Button disabled={isFetching} data-testid="add-new-model-button">
              <PlusSquareIcon />
              Add new model
            </Button>
          </Link>,
        ]}
      />

      {isFetching ? (
        <Spinner />
      ) : (
        <ModelsTable data={data} onClick={redirectToModel} />
      )}
    </div>
  );
};
